import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const CheckmarkScaleSmall = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g>
                <path
                    d="M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
                    stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.99988 8L6.99988 10L10.9999 6"
                    stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    ),
    'Checkmark'
);
export default CheckmarkScaleSmall;
